import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ConfirmationInfo, SelectContact, TokenValidation } from './components'
import { CONFIRM_SUBSCRIPTION_STEPS } from './constants'
import './style.scss'

const COMPONENTS = {
  [CONFIRM_SUBSCRIPTION_STEPS.REVIEW]: ConfirmationInfo,
  [CONFIRM_SUBSCRIPTION_STEPS.SELECT_CONTACT]: SelectContact,
  [CONFIRM_SUBSCRIPTION_STEPS.TOKEN_VALIDATION]: TokenValidation,
}

export function StoreConfirmSubscription() {
  const [currentStep, setCurrentStep] = useState(CONFIRM_SUBSCRIPTION_STEPS.REVIEW)
  const [isLoading, setIsLoading] = useState(false)
  const [contactToken, setContactToken] = useState(null)
  const [contactTokenType, setContactTokenType] = useState(null)
  const {
    modal: { data },
  } = useSelector(({ drawer }) => drawer)
  const { document } = useSelector(({ customer }) => customer.info)

  const { cart = [], totalValue = 0 } = data

  function renderStep() {
    const Step = COMPONENTS[currentStep]

    if (!Step) return null

    return (
      <div className='store-confirm-subscription-modal'>
        <Step
          cart={cart}
          totalValue={totalValue}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setCurrentStep={setCurrentStep}
          document={document}
          setContactToken={setContactToken}
          contactToken={contactToken}
          contactTokenType={contactTokenType}
          setContactTokenType={setContactTokenType}
        />
      </div>
    )
  }

  return renderStep()
}
